import { GlobalWorkerOptions, version } from 'pdfjs-dist'

// Track if the worker has been initialized
let isInitialized = false

/**
 * Default PDF.js document loading options including cMap configuration.
 * Using CDN for cMaps - no local files needed!
 */
export const CMAP_URL = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${version}/cmaps/`
export const CMAP_PACKED = true

const setupPdfs = () => {
  /**
   * Set up PDFs:
   * - Initialize PDFJS
   */
  if (!isInitialized) {
    try {
      // Try to use a more reliable CDN
      GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${version}/build/pdf.worker.min.mjs`
      isInitialized = true
    } catch (error) {
      console.error('Failed to initialize PDF.js worker:', error)
      // Fallback to cdnjs
      try {
        GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${version}/pdf.worker.js`
        isInitialized = true
      } catch (fallbackError) {
        console.error('Failed to initialize PDF.js worker with fallback:', fallbackError)
      }
    }
  }
}
export default setupPdfs
